<template>
	<v-flex xs12 class="other-raports-card-wrapper">
		<v-card class="other-raports-card" :style="'border-bottom: 2px solid' + color_by_status">
			<div class="other-raports-card-top">
				<div class="other-raports-ref-nr">{{ reports_info.rid }}</div>
				<div class="other-raports-categorie">{{ getStateWithParam(reports_info.kategoria) }}</div>
			</div>
			<div class="other-raports-card-middle">
				<v-icon>location_on</v-icon>
				<div class="other-raports-location">{{ reports_info.adresa }}</div>
			</div>
			<div class="d-flex other-raports-card-bottom">
				<div v-if="status" class="other-raports-statuslabel" :style="'color: ' + status.color">{{ getStatusLabel(status) }}</div>
				<div class="other-raports-date">{{ reports_info.data_in }}</div>
			</div>
		</v-card>
	</v-flex>
</template>

<script>
export default {
	name: 'OtherRaportCard',
	props: {
		reports_info: {
			type: Object,
			required: false,
		},
		status: {
			type: [Object],
			required: null,
		},
		color_by_status: {
			type: [String],
			required: false,
		},
		make_reply: {
			type: [Array, String, Boolean, Object],
			required: false,
		},
	},

	data() {
		return {};
	},
	methods: {
		viewDetailRaport() {
			var raport_detail = {
				item_report: this.reports_info,
				item_report_reply: typeof this.reports_info.reply == 'string' || this.reports_info.reply == undefined ? [] : this.reports_info.reply.reverse(),
				show_reply_report: this.make_reply,
				raportIdReplay: this.make_reply ? this.reports_info.rid : '',
			};

			localStorage.raport_detail = JSON.stringify(raport_detail);

			this.$router.push({
				name: 'ViewReportDetail',
				params: raport_detail,
			});
		},
		getStatusLabel(status) {
			let label = '';
			if (status) {
				if (Number(this.$store.state.type_language) === 1) {
					label = status.code_al;
				} else if (Number(this.$store.state.type_language) === 2) {
					label = status.code_en;
				}
			}
			return label;
		},
		getStateWithParam(categoria) {
			switch (categoria) {
				case '0':
				case 0:
					return this.$store.getters.getLanguageParameters('report_pollution');
					break;
				case 1:
				case '1':
					return this.$store.getters.getLanguageParameters('report_infrastructure');
					break;
				case 2:
				case '2':
					return this.$store.getters.getLanguageParameters('report_illegal_construction');
					break;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.other-raports-card-wrapper {
	padding: 7px !important;
	.other-raports-card {
		background-color: white;
		border: 0;
		box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05) !important;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		padding: 15px;
		position: relative !important;
		justify-content: center;
		.other-raports-card-top {
			display: flex;
			justify-content: space-between;
			font-size: 12px;
			font-weight: 700;
			text-transform: uppercase;
			padding-bottom: 7px;
		}
		.other-raports-card-middle {
			display: flex;
			.v-icon {
				font-size: 20px;
				color: #e60000;
			}
		}
		.other-raports-card-bottom {
			display: flex;
			justify-content: space-between;
			font-size: 10px;
			padding-top: 10px;
			letter-spacing: 0.5px;
		}
		.other-raports-date {
			text-align: right;
		}
	}
}
</style>
